/**
 * @param element {HTMLElement}
 * @param styles {{[K in keyof CSSStyleDeclaration]: string}}
 * @param priority {string}
 * */
export function applyInlineStyles(element, styles) {
  let priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  for (let prop in styles) {
    element.style.setProperty(prop, styles[prop], priority);
  }
}